import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

interface UserUsageStats {
	readonly doneTasks: number;
	readonly pendingTasks: number;
	readonly messagesSent: number;
	readonly messagesSentMax: number;
	readonly messagesSentPeriod: number;
	readonly doneJobMeetings: number;
	readonly pendingJobMeetings: number;
	readonly doneContactMeetings: number;
	readonly pendingContactMeetings: number;
}

export interface AppSharedRepositoryState {
	readonly userPendingMessages: { [p: string]: number };
	readonly userUsageStats: UserUsageStats;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'app-shared-repository' })
export class AppSharedRepositoryStore extends Store<AppSharedRepositoryState> {
	constructor() {
		super({
			userUsageStats: {
				doneTasks: 0,
				pendingTasks: 0,
				doneJobMeetings: 0,
				pendingJobMeetings: 0,
				doneContactMeetings: 0,
				pendingContactMeetings: 0,
				messagesSent: 0,
				messagesSentMax: 100,
				messagesSentPeriod: 1,
			},
		});
	}
}
